export default __webpack_public_path__ + "static/media/email-sent.f571e85d.svg";